import React, { useState, useEffect, useRef } from "react";
import Index from "../../../../../component/Index";
import { useDispatch } from "react-redux";
import { useReactToPrint } from "react-to-print";

import { useParams } from "react-router-dom";
import { getPurchasePrintDataApiHandler } from "../../../../../services/AdminIndex";
import moment from "moment";
import QRImage from "../../salesEntry/invoice/qr-download.png";
import { ToWords } from "to-words";
import { QRCodeSVG } from "qrcode.react";
import { jwtDecode } from "jwt-decode";

export default function Preview({ id: printId, onPrintReady } = {}) {
  const params = useParams();
  // Multiple Document Print (Utility) passes the id as a prop
  const id = printId ?? params.id;
  const editId = id;
  const toWords = new ToWords();

  const dispatch = useDispatch();
  const [productData, setProductData] = useState([]);
  const [poData, setPoData] = useState([]);
  const [companyAddress, setCompanyAddress] = useState();
  const [supplierAddress, setSupplierAddress] = useState();
  const [printData, setPrintData] = useState({});
  const [taxData, setTaxData] = useState([]);
  const [bankDetails, setBankDetails] = useState({});
  const [decodedQRData, setDecodedQRData] = useState("");

  const { token } = Index.useSelector((state) => {
    return state.ERPAdminReducer;
  });

  const getPrintData = () => {
    dispatch({ type: "LOADER_START" });
    getPurchasePrintDataApiHandler(token, editId).then((data) => {
      dispatch({ type: "LOADER_START" });
      if (data.status === 201 || data.status === 200) {
        setPrintData(data?.data);

        const companyAddress = parseData(data?.data?.companyAddress);
        setCompanyAddress(companyAddress?.[0]);
        const bankDetails = parseData(data?.data?.bankDetails);
        setBankDetails(bankDetails?.[0]);
        const productData = parseData(data?.data?.productData);
        setProductData(productData);

        const tax = parseData(data?.data?.taxData);
        setTaxData(tax);
        if (data?.data?.QRCode) {
          const decodedQR = jwtDecode(data?.data?.QRCode);
          setDecodedQRData(decodedQR);
        }
        const poData = parseData(data?.data?.purchaseOrderData);
        setPoData(poData);

        const supplierAddress = parseData(data?.data?.supplierAddress);
        setSupplierAddress(supplierAddress?.[0]);

        dispatch({ type: "LOADER_END" });
      } else {
        dispatch({ type: "ADMIN_ERROR_HANDLER", payload: data });
      }
    });
  };

  // Call edit API
  useEffect(() => {
    getPrintData();
  }, []);

  const parseData = (data) => {
    try {
      // if plain js
      if (data) {
        let result = JSON.parse(data);
        return result;
      } else {
        return [];
      }
    } catch (e) {
      return [];
    }
  };

  const printRef = useRef();

  // Multiple Document Print (Utility): report this document's printRef once its data is in
  useEffect(() => {
    if (onPrintReady && Object.keys(printData || {}).length) onPrintReady(printRef);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [printData]);

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    repeatTableHead: true,
  });

  // if (loading) {
  //   <LoadingSpinner></LoadingSpinner>;
  // } else {
  return (
    <>
      <div className="grn-print-container" ref={printRef}>
        <div className="grn-order-print" style={{ margin: "10px" }}>
          <table
            style={{
              backgroundColor: "#fff",
              margin: "auto",
              border: "1px solid #9f9e9e",
              width: "100%",
            }}
            border={0}
            cellSpacing={0}
            cellPadding={0}
            role="presentation"
          >
            <tbody>
              <tr>
                <td
                  colSpan={5}
                  style={{
                    border: "1px solid #9f9e9e",
                    padding: "10px",
                  }}
                >
                  <table
                    border={0}
                    cellSpacing={0}
                    cellPadding={0}
                    style={{ border: 0, width: "100%" }}
                  >
                    <tr>
                      <td
                        style={{
                          width: "20%",
                          paddingLeft: "20px",
                        }}
                      >
                        {printData?.companyLogo ? (
                          <img
                            src={
                              process.env.REACT_APP_IMAGE_URL +
                              printData?.companyLogo
                            }
                            // height="60px"
                            // width="100px"
                            style={{
                              objectFit: "contain",
                              height: "100%",
                              width: "100%",
                              maxWidth: "100px",
                              maxHeight: "60px",
                            }}
                          />
                        ) : (
                          <></>
                        )}
                      </td>
                      <td>
                        <tr>
                          <td
                            style={{
                              fontSize: 15,
                              lineHeight: 1.2,
                              color: "#666666",
                              verticalAlign: "top",
                              borderBottom: 0,
                              textAlign: "center",
                              width: "40%",
                            }}
                          >
                            <h2
                              style={{
                                color: "#222222",
                                margin: "0px 0px 5px 0px",
                                fontSize: "25px",
                              }}
                            >
                              {companyAddress?.Company_name}
                            </h2>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              borderBottom: 0,
                              fontSize: 11,
                              lineHeight: 1.2,
                              padding: "1px 10px 5px",
                              color: "#666666",
                              verticalAlign: "middle",
                              paddingTop: 0,
                              paddingBottom: 0,
                              textAlign: "center",
                            }}
                            className="address"
                          >
                            <p
                              style={{
                                textAlign: "center",
                                lineHeight: 1.2,
                                margin: 0,
                                fontSize: 11,
                                color: "#666666",
                              }}
                            >
                              {`${companyAddress?.o_add1 || ""}, ${companyAddress?.o_add2 || ""
                                }, `}
                            </p>
                            <p
                              style={{
                                textAlign: "center",
                                lineHeight: 1.2,
                                margin: 0,
                                fontSize: 11,
                                color: "#666666",
                              }}
                            >
                              {`${companyAddress?.o_add3 || ""}, ${companyAddress?.cityName || ""
                                } - ${companyAddress?.o_pin || ""}, ${companyAddress?.Statename || ""
                                } - ${companyAddress?.sCode || ""}`}
                            </p>
                            <p
                              style={{
                                textAlign: "center",
                                lineHeight: 1.2,
                                margin: 0,
                                fontSize: 11,
                                color: "#666666",
                              }}
                            >
                              Contact No : {printData.companyMobileNo}, Email Id
                              : {printData.companyEmail}
                            </p>
                            <p
                              style={{
                                textAlign: "center",
                                lineHeight: 2,
                                margin: 0,
                                fontWeight: "700",
                                fontSize: 11,
                                color: "#666666",
                                letterSpacing: "1.2px",
                              }}
                            >
                              GSTIN NO : {printData.companyGSTNo}, PAN NO :
                              {printData.companyPanNo}
                            </p>
                            <p />
                          </td>
                        </tr>
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                          width: "20%",
                          paddingRight: "20px",
                        }}
                      >
                        {decodedQRData && (
                          <QRCodeSVG
                            value={JSON.stringify(decodedQRData)}
                            size={80}
                            level="H"
                          />
                        )}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td style={{ padding: "0px" }}>
                  <table
                    style={{
                      width: "100%",
                      backgroundColor: "#efefef",
                      borderBottom: "1px solid #9f9e9e",
                      borderCollapse: "collapse",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td style={{ width: "100%", padding: "3px" }}>
                          <h3
                            style={{
                              textTransform: "uppercase",
                              fontSize: "11px",
                              lineHeight: "16px",
                              color: "#000",
                              margin: "0px",
                              fontFamily: '"popins-regular", sans-serif',
                              textAlign: "center",
                            }}
                          >
                            DEBIT NOTE
                          </h3>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td style={{ padding: "0px" }}>
                  <table
                    style={{
                      borderBottom: "1px solid #9f9e9e",
                      borderCollapse: "collapse",
                      width: "100%",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td
                          className="padding-none"
                          width="50%"
                          style={{
                            // borderRight: "1px solid #9f9e9e",
                            fontSize: 10,
                            padding: 0,
                            color: "#666666",
                            verticalAlign: "top",
                            // border: 0,
                          }}
                        >
                          <table
                            border={0}
                            cellSpacing={0}
                            cellPadding={0}
                            style={{
                              width: "100%",
                            }}
                          >
                            <tbody>
                              <tr>
                                <td
                                  className="label"
                                  style={{
                                    // borderRight: "1px solid #9f9e9e",
                                    fontSize: 10,
                                    padding: "1px 6px",
                                    color: "#666666",
                                    verticalAlign: "top",
                                  }}
                                >
                                  <p style={{ margin: "0 0 0px" }}>
                                    <b style={{ color: "#222222" }}>
                                      {`To : ${printData?.supplier || ""}`}
                                    </b>
                                  </p>
                                  <p
                                    style={{
                                      margin: "0 0 0px",
                                      minHeight: "18px",
                                    }}
                                  >
                                    {supplierAddress?.address1}
                                  </p>
                                  <p
                                    style={{
                                      margin: "0 0 0px",
                                      minHeight: "18px",
                                    }}
                                  >
                                    {supplierAddress?.address2}
                                  </p>
                                  <p
                                    style={{
                                      margin: "0 0 0px",
                                      minHeight: "18px",
                                    }}
                                  >
                                    {supplierAddress?.address3}
                                  </p>
                                  <p
                                    style={{
                                      margin: "0 0 0px",
                                      minHeight: "18px",
                                    }}
                                  >
                                    {`${supplierAddress?.cityName || ""} - ${supplierAddress?.pin || ""
                                      }, ${supplierAddress?.Statename || ""} - ${supplierAddress?.sCode || ""
                                      }`}
                                  </p>
                                  <p
                                    style={{
                                      margin: "0 0 0px",
                                      minHeight: "18px",
                                    }}
                                  >
                                    GSTIN NO : {printData?.supplierGSTNo || ""}
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;PAN
                                    NO : {printData?.supplierPanNo || ""}
                                  </p>
                                  <p
                                    style={{
                                      margin: "0 0 0px",
                                      minHeight: "18px",
                                    }}
                                  >
                                    Contact No :{" "}
                                    {`${printData?.supplierMobile || ""}/${printData?.supplierOfficeNumber || ""
                                      }`}
                                  </p>
                                  {printData?.supplierMSME &&
                                    printData?.supplierMSME != 0 && (
                                      <p
                                        style={{
                                          margin: "0 0 0px",
                                          minHeight: "18px",
                                        }}
                                      >
                                        MSME No :{" "}
                                        {printData?.supplierMSME || ""}
                                      </p>
                                    )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td
                          style={{
                            padding: "0px",
                            width: "50%",
                            borderLeft: "1px solid #9f9e9e",
                            verticalAlign: "top",
                          }}
                        >
                          <table style={{ width: "100%" }}>
                            <tbody>
                              <tr>
                                <td
                                  style={{
                                    width: "100%",
                                    borderBottom: "1px solid #9f9e9e",
                                    padding: "0px 0px 0px 0px",
                                  }}
                                >
                                  <table>
                                    <tbody>
                                      <tr>
                                        <td
                                          className="label"
                                          style={{
                                            fontSize: 10,
                                            lineHeight: 1.5,
                                            padding: "3.5px 6px",
                                            color: "#666666",
                                            verticalAlign: "top",
                                            width: "50%",
                                          }}
                                        >
                                          <b style={{ color: "#222222" }}>
                                            Debit No:
                                          </b>
                                          <span style={{ paddingLeft: "18px" }}>
                                            {printData?.noteNo}
                                          </span>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td
                                          className="label"
                                          style={{
                                            fontSize: 10,
                                            lineHeight: 1.5,
                                            padding: "3.5px 6px",
                                            color: "#666666",
                                            verticalAlign: "top",
                                            width: "50%",
                                          }}
                                        >
                                          <b style={{ color: "#222222" }}>
                                            Date:
                                          </b>
                                          <span style={{ paddingLeft: "38px" }}>
                                            {moment(printData?.noteDate).format(
                                              "DD/MM/YYYY",
                                            )}
                                          </span>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style={{ padding: "0px" }}></td>
                                      </tr>
                                      <tr>
                                        <td style={{ padding: "0px" }}></td>
                                      </tr>
                                      <tr>
                                        <td style={{ padding: "0px" }}></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <table style={{ width: "100%" }}>
                                    <tbody>
                                      <tr>
                                        <td
                                          className="label"
                                          style={{
                                            fontSize: 10,
                                            lineHeight: 1.5,
                                            padding: "3.5px 6px",
                                            color: "#666666",
                                            verticalAlign: "top",
                                            width: "50%",
                                          }}
                                        >
                                          <b style={{ color: "#222222" }}>
                                            NOTE:
                                          </b>
                                          <span style={{ paddingLeft: "32px" }}>
                                            GOOD RETURN AGAINST
                                          </span>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td
                                          className="label"
                                          style={{
                                            fontSize: 10,
                                            lineHeight: 1.5,
                                            padding: "3.5px 6px",
                                            color: "#666666",
                                            verticalAlign: "top",
                                            width: "50%",
                                          }}
                                        >
                                          <b style={{ color: "#222222" }}>
                                            Bill No:
                                          </b>
                                          <span style={{ paddingLeft: "29px" }}>
                                            {printData?.againstBillNo}
                                          </span>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td
                                          className="label"
                                          style={{
                                            fontSize: 10,
                                            lineHeight: 1.5,
                                            padding: "3.5px 6px",
                                            color: "#666666",
                                            verticalAlign: "top",
                                            width: "50%",
                                          }}
                                        >
                                          <b style={{ color: "#222222" }}>
                                            Bill Date:
                                          </b>
                                          <span style={{ paddingLeft: "20px" }}>
                                            {printData?.againstBillDate
                                              ? moment(
                                                printData?.againstBillDate,
                                              ).format("DD-MM-YYYY")
                                              : "-"}
                                          </span>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td style={{ padding: "0px" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr>
                        <th
                          style={{
                            fontSize: "11px",
                            lineHeight: "16px",
                            color: "#222222",
                            margin: "0px",
                            textAlign: "left",
                            borderRight: "1px solid #9f9e9e",
                            borderBottom: "1px solid #9f9e9e",
                            backgroundColor: "#efefef",
                            padding: "3px 6px",
                            width: "3%",
                          }}
                        >
                          Sr.
                        </th>
                        <th
                          style={{
                            fontSize: "11px",
                            lineHeight: "16px",
                            color: "#222222",
                            margin: "0px",
                            textAlign: "left",
                            borderRight: "1px solid #9f9e9e",
                            borderBottom: "1px solid #9f9e9e",
                            backgroundColor: "#efefef",
                            padding: "3px 6px",
                            width: "37%",
                          }}
                        >
                          Product
                        </th>
                        <th
                          style={{
                            fontSize: "11px",
                            lineHeight: "16px",
                            color: "#222222",
                            margin: "0px",
                            textAlign: "left",
                            borderRight: "1px solid #9f9e9e",
                            borderBottom: "1px solid #9f9e9e",
                            backgroundColor: "#efefef",
                            padding: "3px 6px",
                            width: "8%",
                          }}
                        >
                          HSN
                        </th>
                        <th
                          style={{
                            fontSize: "11px",
                            lineHeight: "16px",
                            color: "#222222",
                            margin: "0px",
                            textAlign: "left",
                            borderRight: "1px solid #9f9e9e",
                            borderBottom: "1px solid #9f9e9e",
                            backgroundColor: "#efefef",
                            padding: "3px 6px",
                            width: "8%",
                          }}
                        >
                          Colour
                        </th>
                        <th
                          style={{
                            fontSize: "11px",
                            lineHeight: "16px",
                            color: "#222222",
                            margin: "0px",
                            textAlign: "left",
                            borderRight: "1px solid #9f9e9e",
                            borderBottom: "1px solid #9f9e9e",
                            backgroundColor: "#efefef",
                            padding: "3px 6px",
                            width: "8%",
                          }}
                        >
                          Size
                        </th>
                        <th
                          style={{
                            fontSize: "11px",
                            lineHeight: "16px",
                            color: "#222222",
                            margin: "0px",
                            textAlign: "left",
                            borderRight: "1px solid #9f9e9e",
                            borderBottom: "1px solid #9f9e9e",
                            backgroundColor: "#efefef",
                            padding: "3px 6px",
                            width: "8%",
                          }}
                        >
                          Unit
                        </th>
                        <th
                          style={{
                            fontSize: "11px",
                            lineHeight: "16px",
                            color: "#222222",
                            margin: "0px",
                            textAlign: "left",
                            borderRight: "1px solid #9f9e9e",
                            borderBottom: "1px solid #9f9e9e",
                            backgroundColor: "#efefef",
                            padding: "3px 6px",
                            width: "8%",
                          }}
                        >
                          Qty
                        </th>
                        <th
                          style={{
                            fontSize: "11px",
                            lineHeight: "16px",
                            color: "#222222",
                            margin: "0px",
                            textAlign: "left",
                            borderRight: "1px solid #9f9e9e",
                            borderBottom: "1px solid #9f9e9e",
                            backgroundColor: "#efefef",
                            padding: "3px 6px",
                            width: "8%",
                          }}
                        >
                          Rate
                        </th>
                        <th
                          style={{
                            fontSize: "11px",
                            lineHeight: "16px",
                            color: "#222222",
                            margin: "0px",
                            textAlign: "right",
                            // borderRight: "1px solid #9f9e9e",
                            borderBottom: "1px solid #9f9e9e",
                            backgroundColor: "#efefef",
                            padding: "3px 6px",
                            width: "8%",
                          }}
                        >
                          Amount
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {productData.map((row, index) => (
                        <tr style={{ borderBottom: "1px solid #9f9e9e" }}>
                          <td
                            style={{
                              fontSize: 9,
                              lineHeight: "16px",
                              fontWeight: 400,
                              color: "#222222",
                              margin: "0px",
                              textAlign: "left",
                              borderRight: "1px solid #9f9e9e",
                              padding: "5px",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{
                              fontSize: 9,
                              lineHeight: "16px",
                              fontWeight: 400,
                              color: "#222222",
                              margin: "0px",
                              textAlign: "left",
                              borderRight: "1px solid #9f9e9e",
                              padding: "5px",
                            }}
                          >
                            {row?.ProductName || ""}
                          </td>
                          <td
                            style={{
                              fontSize: 9,
                              lineHeight: "16px",
                              fontWeight: 400,
                              color: "#222222",
                              margin: "0px",
                              textAlign: "left",
                              borderRight: "1px solid #9f9e9e",
                              padding: "5px",
                            }}
                          >
                            {row?.HSNCode || ""}
                          </td>
                          <td
                            style={{
                              fontSize: 9,
                              lineHeight: "16px",
                              fontWeight: 400,
                              color: "#222222",
                              margin: "0px",
                              textAlign: "left",
                              borderRight: "1px solid #9f9e9e",
                              padding: "5px",
                            }}
                          >
                            {row?.color_name || ""}
                          </td>
                          <td
                            style={{
                              fontSize: 9,
                              lineHeight: "16px",
                              fontWeight: 400,
                              color: "#222222",
                              margin: "0px",
                              textAlign: "left",
                              borderRight: "1px solid #9f9e9e",
                              padding: "5px",
                            }}
                          >
                            {row?.size_name || ""}
                          </td>
                          <td
                            style={{
                              fontSize: 9,
                              lineHeight: "16px",
                              fontWeight: 400,
                              color: "#222222",
                              margin: "0px",
                              textAlign: "left",
                              borderRight: "1px solid #9f9e9e",
                              padding: "5px",
                            }}
                          >
                            {row?.unitCode || ""}
                          </td>
                          <td
                            style={{
                              fontSize: 9,
                              lineHeight: "16px",
                              fontWeight: 400,
                              color: "#222222",
                              margin: "0px",
                              textAlign: "left",
                              borderRight: "1px solid #9f9e9e",
                              padding: "5px",
                            }}
                          >
                            {Number(row?.qty || 0).toFixed(2)}
                          </td>
                          <td
                            style={{
                              fontSize: 9,
                              lineHeight: "16px",
                              fontWeight: 400,
                              color: "#222222",
                              margin: "0px",
                              textAlign: "left",
                              borderRight: "1px solid #9f9e9e",
                              padding: "5px",
                            }}
                          >
                            {Number(row?.rate || 0).toFixed(2)}
                          </td>
                          <td
                            style={{
                              fontSize: 9,
                              lineHeight: "16px",
                              fontWeight: 400,
                              color: "#222222",
                              margin: "0px",
                              textAlign: "left",
                              // borderRight: "1px solid #9f9e9e",
                              padding: "5px",
                              textAlign: "right",
                            }}
                          >
                            {Number(row?.amount || 0).toFixed(2)}
                          </td>
                        </tr>
                      ))}
                      {Array.from(Array(15).keys()).map((row, index) => (
                        <tr key={index}>
                          <td
                            style={{
                              fontSize: 9,
                              padding: "1px 6px",
                              // borderRight: "1px solid #9f9e9e",
                              height: 20,
                              color: "#ffffff",
                              verticalAlign: "top",
                              textAlign: "center",
                            }}
                          >
                            {index}
                          </td>
                          <td
                            style={{
                              height: 20,
                            }}
                          />
                          <td
                            style={{
                              height: 20,
                            }}
                          />
                          <td style={{ height: 20 }} />
                        </tr>
                      ))}
                      <td colSpan={9}>
                        <tr>
                          <td>
                            <table
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    style={{
                                      fontSize: "10px",
                                      lineHeight: "16px",
                                      fontWeight: 400,
                                      // color: "#666666",
                                      fontWeight: "bold",
                                      margin: 0,
                                      textAlign: "left",
                                      borderTop: "1px solid #9f9e9e",
                                      borderRight: "1px solid #9f9e9e",
                                      borderBottom: "1px solid #9f9e9e",
                                      padding: "3px 15px",
                                      width: "83.3%",
                                    }}
                                  >
                                    MSME NO.:{printData?.MSMENo}
                                    <span style={{ marginLeft: "245px" }}>
                                      Eway Bill NO.:{" "}
                                      {printData?.ewaybillno || ""}
                                    </span>
                                  </td>

                                  <td
                                    style={{
                                      fontSize: "10px",
                                      lineHeight: "16px",
                                      fontWeight: 400,
                                      // color: "#666666",
                                      fontWeight: 400,
                                      margin: 0,
                                      textAlign: "left",
                                      padding: "3px 15px",
                                      borderTop: "1px solid #9f9e9e",
                                      borderRight: "1px solid #9f9e9e",
                                      borderBottom: "1px solid #9f9e9e",
                                      width: "8.3%%",
                                    }}
                                  >
                                    Total
                                  </td>
                                  <td
                                    style={{
                                      fontSize: "10px",
                                      lineHeight: "16px",
                                      fontWeight: 400,
                                      // color: "#666666",
                                      margin: 0,
                                      fontWeight: "bold",

                                      textAlign: "right",
                                      padding: "3px 15px",
                                      borderTop: "1px solid #9f9e9e",
                                      borderBottom: "1px solid #9f9e9e",
                                      width: "8.4%",
                                    }}
                                  >
                                    {(() => {
                                      const products = JSON.parse(
                                        printData?.productData || "[]",
                                      );

                                      const total = products.reduce(
                                        (sum, item) => {
                                          return sum + (item.amount || 0);
                                        },
                                        0,
                                      );

                                      return total.toFixed(2);
                                    })()}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <table
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                                borderBottom: "1px solid #9f9e9e",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    style={{
                                      width: "67%",
                                      borderRight: "1px solid #9f9e9e",
                                      verticalAlign: "top",
                                      padding: 0,
                                    }}
                                  >
                                    <table
                                      style={{
                                        borderCollapse: "collapse",
                                        width: "100%",
                                      }}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            style={{
                                              width: "25%",
                                              fontSize: 10,
                                              padding: "4px 8px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            Bank Name
                                          </td>
                                          <td style={{ width: "2%" }}>:</td>
                                          <td
                                            style={{
                                              width: "23%",
                                              fontSize: 10,
                                            }}
                                          >
                                            {bankDetails?.BankName || ""}
                                          </td>
                                          <td
                                            style={{
                                              width: "25%",
                                              fontSize: 10,
                                              padding: "4px 8px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            Branch Name
                                          </td>
                                          <td style={{ width: "2%" }}>:</td>
                                          <td
                                            style={{
                                              width: "23%",
                                              fontSize: 10,
                                            }}
                                          >
                                            {bankDetails?.Branchname || ""}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            style={{
                                              fontSize: 10,
                                              padding: "4px 8px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            A/C No
                                          </td>
                                          <td>:</td>
                                          <td style={{ fontSize: 10 }}>
                                            {bankDetails?.Ac_No || ""}
                                          </td>
                                          <td
                                            style={{
                                              fontSize: 10,
                                              padding: "4px 8px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            IFSC Code
                                          </td>
                                          <td>:</td>
                                          <td style={{ fontSize: 10 }}>
                                            {bankDetails?.IFSC_code || ""}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            colSpan={6}
                                            style={{
                                              borderTop: "1px solid #9f9e9e",
                                              padding: "4px 8px",
                                              fontSize: 9,
                                            }}
                                          >
                                            <p
                                              style={{
                                                margin: "0 0 2px 0",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              Terms & Conditions
                                            </p>
                                            <p style={{ margin: 0 }}>
                                              1) Payment within 30 Days.
                                            </p>
                                            <p style={{ margin: 0 }}>
                                              2) In case of unpaid bill intrest
                                              @24% will be charge extra from the
                                              date of bill
                                            </p>
                                            <p style={{ margin: 0 }}>
                                              3) Subject to MUMBAI jurisdiction
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            colSpan={6}
                                            style={{
                                              borderTop: "1px solid #9f9e9e",
                                              padding: "4px 8px",
                                              fontSize: 9,
                                            }}
                                          >
                                            <p style={{ margin: "0 0 2px 0" }}>
                                              <b>IRN No. :</b>{" "}
                                              {printData?.IrnNo}
                                            </p>
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                              }}
                                            >
                                              <span>
                                                <b>ACK No. :</b>{" "}
                                                {printData?.AckNo}
                                              </span>
                                              <span
                                                style={{ fontWeight: "bold" }}
                                              >
                                                E & O.E
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                  <td
                                    style={{
                                      width: "30%",
                                      verticalAlign: "top",
                                    }}
                                  >
                                    <table
                                      style={{
                                        borderCollapse: "collapse",
                                        width: "100%",
                                      }}
                                    >
                                      <tbody>
                                        {taxData?.map((tax, index) => (
                                          <tr key={index}>
                                            <td
                                              style={{
                                                borderBottom:
                                                  "1px solid #9f9e9e",
                                                borderRight:
                                                  "1px solid #9f9e9e",
                                                fontSize: 10,
                                                padding: "4px 8px",
                                                textAlign: "center",
                                                fontWeight: 600,
                                                width: "73%",
                                              }}
                                            >
                                              {[
                                                "C.GST",
                                                "I.GST",
                                                "S.GST",
                                              ].includes(tax?.tax_type)
                                                ? `+${tax?.tax_type} ${tax?.taxRate}% ON ${tax?.taxOnAmt ?? ""}`
                                                : `${tax?.tax_name}`}
                                            </td>
                                            <td
                                              style={{
                                                borderBottom:
                                                  "1px solid #9f9e9e",
                                                fontSize: 10,
                                                padding: "4px 8px",
                                                textAlign: "right",
                                                fontWeight: 600,
                                                width: "40%",
                                              }}
                                            >
                                              {tax?.amount}
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    style={{
                                      borderTop: "1px solid #9f9e9e",
                                      borderRight: "1px solid #9f9e9e",
                                      padding: "4px 8px",
                                      fontSize: 10,
                                      fontWeight: "bold",
                                      borderBottom: "1px solid #9f9e9e",
                                    }}
                                  >
                                    Rupees :{" "}
                                    {printData.totalAmount
                                      ? `${toWords.convert(printData.totalAmount)} Only.`
                                      : ""}
                                  </td>
                                  <td
                                    style={{
                                      padding: 0,
                                      verticalAlign: "top",
                                      borderBottom: "1px solid #9f9e9e",
                                    }}
                                  >
                                    <table
                                      style={{
                                        width: "100%",
                                        borderCollapse: "collapse",
                                      }}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            style={{
                                              width: "60%",
                                              fontSize: 11,
                                              padding: "4px 8px",
                                              fontWeight: "bold",
                                              borderRight: "1px solid #9f9e9e",
                                              borderTop: "1px solid #9f9e9e",
                                              textAlign: "center",
                                            }}
                                          >
                                            NET AMOUNT
                                          </td>
                                          <td
                                            style={{
                                              width: "40%",
                                              fontSize: 11,
                                              padding: "4px 8px",
                                              fontWeight: "bold",
                                              textAlign: "right",
                                              borderTop: "1px solid #9f9e9e",
                                            }}
                                          >
                                            {Number(
                                              printData.totalAmount,
                                            ).toFixed(2)}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan={2} style={{ padding: "0px" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        width: "100%",
                                        alignItems: "stretch",
                                      }}
                                    >
                                      <div
                                        style={{
                                          width: "50%",
                                          fontSize: 9,
                                          padding: "8px",
                                        }}
                                      >
                                        <p style={{ margin: 0 }}>
                                          I/We hereby certify that my / our
                                          Registration certificate under The GST
                                          Act 2017 printing is in force on the
                                          date on which the sale of the goods
                                          specified in this bill / cash
                                          Memorandum is made by me/us and that
                                          the transaction of sale covered by
                                          this bill/cash memorandum has been
                                          effected by my / us in the regular
                                          course of my / our business.
                                        </p>
                                      </div>
                                      <div
                                        style={{
                                          width: "25%",
                                          fontSize: 9,
                                          padding: "8px",
                                          borderLeft: "1px solid #9f9e9e",
                                          borderRight: "1px solid #9f9e9e",
                                        }}
                                      >
                                        <p style={{ margin: 0 }}>
                                          If any Dispute arises about
                                          transaction the same shall have to be
                                          referred to the HINDUSTAN CHAMBER OF
                                          COMMERCE / CMAI, Mumbai for under its
                                          arbitration rules and award made there
                                          under shall be binding upon.
                                        </p>
                                      </div>
                                      <div
                                        style={{
                                          width: "33.5%",
                                          textAlign: "right",
                                          fontSize: 11,
                                          padding: "8px",
                                        }}
                                      >
                                        <p
                                          style={{
                                            fontWeight: "bold",
                                            margin: "0 0 30px 0",
                                          }}
                                        >
                                          For{" "}
                                          {companyAddress?.Company_name || ""}
                                        </p>
                                        <p
                                          style={{
                                            fontWeight: "bold",
                                            margin: 0,
                                          }}
                                        >
                                          Authorised Signatory
                                        </p>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </td>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="print-button">
        <Index.Box className="btn-primary-main">
          <Index.Button
            variant="contained"
            onClick={() => handlePrint()}
            className="btn-primary"
          >
            Print
          </Index.Button>
        </Index.Box>
        <div style={{ display: "none" }}>
          <PrintComponent
            printRef={printRef}
            printData={printData}
            companyAddress={companyAddress}
            supplierAddress={supplierAddress}
            productData={productData}
            poData={poData}
            taxData={taxData}
            bankDetails={bankDetails}
            decodedQRData={decodedQRData}
            toWords={toWords}
          />
        </div>
      </div>
    </>
  );
}

const PrintComponent = (props) => {
  let {
    printRef,
    printData,
    companyAddress,
    supplierAddress,
    productData,
    taxData,
    bankDetails,
    decodedQRData,
    toWords,
  } = props;

  const dataPerPage = 13;

  const [formattedData, setFormattedData] = useState([]);

  const calculatePageNo = () => {
    let pages = Math.ceil(productData?.length / dataPerPage) || 1;
    const data = Array.from({ length: pages })?.map((_, i) => {
      const page = i + 1;
      const isLastPage = pages - 1 === i;
      const pageTotalQuantity = Number(
        productData
          ?.slice(dataPerPage * i, dataPerPage * (i + 1))
          ?.reduce((acc, curr) => {
            return acc + curr?.qty;
          }, 0) || 0,
      ).toFixed(2);
      const totalQty = Number(printData?.totalQty || 0).toFixed(2);
      const emptyData =
        dataPerPage -
        productData?.slice(
          dataPerPage * (Math.ceil(productData?.length / dataPerPage) - 1),
        )?.length;
      return {
        page,
        rows: productData?.slice(dataPerPage * i, dataPerPage * (i + 1)),
        pageTotalQty: isLastPage ? totalQty : pageTotalQuantity,
        isLastPage,
        emptyData,
      };
    });

    setFormattedData(data);
  };

  useEffect(() => {
    calculatePageNo();
  }, [productData, printData]);

  return (
    <div className="">
      <div className="border">
        <div
          className="purchase-order-print-container"
          style={{ margin: 15 }}
          ref={printRef}
        >
          {formattedData?.map((rowData, i) => {
            const { page, pageTotalQty, isLastPage, emptyData } = rowData;
            return (
              <div
                className="purchase-order-print"
                style={{ padding: "10px 20px" }}
              >
                <table
                  style={{
                    backgroundColor: "#fff",
                    margin: "auto",
                    border: "1px solid #9f9e9e",
                    width: "100%",
                  }}
                  border={0}
                  cellSpacing={0}
                  cellPadding={0}
                  role="presentation"
                >
                  <thead>
                    {/* ── HEADER: Company info ── */}
                    <tr>
                      <td
                        colSpan={5}
                        style={{
                          border: "1px solid #9f9e9e",
                          padding: "10px ",
                        }}
                      >
                        <table
                          border={0}
                          cellSpacing={0}
                          cellPadding={0}
                          style={{ border: 0, width: "100%" }}
                        >
                          <tr>
                            <td style={{ width: "20%", paddingLeft: "20px" }}>
                              {printData?.companyLogo ? (
                                <img
                                  src={
                                    process.env.REACT_APP_IMAGE_URL +
                                    printData?.companyLogo
                                  }
                                  style={{
                                    objectFit: "contain",
                                    height: "100%",
                                    width: "100%",
                                    maxWidth: "100px",
                                    maxHeight: "60px",
                                  }}
                                />
                              ) : (
                                <></>
                              )}
                            </td>
                            <td>
                              <tr>
                                <td
                                  style={{
                                    fontSize: 15,
                                    lineHeight: 1.2,
                                    color: "#666666",
                                    verticalAlign: "top",
                                    borderBottom: 0,
                                    textAlign: "center",
                                    width: "40%",
                                  }}
                                >
                                  <h2
                                    style={{
                                      color: "#222222",
                                      margin: "0px 0px 5px 0px",
                                      fontSize: "25px",
                                    }}
                                  >
                                    {companyAddress?.Company_name}
                                  </h2>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    // borderBottom: 0,
                                    fontSize: 11,
                                    lineHeight: 1.2,
                                    padding: "2px 10px 5px",
                                    color: "#666666",
                                    verticalAlign: "middle",
                                    // paddingTop: 0,
                                    // paddingBottom: 0,
                                    textAlign: "center",
                                  }}
                                  className="address"
                                >
                                  <p
                                    style={{
                                      textAlign: "center",
                                      lineHeight: 1.2,
                                      margin: 0,
                                      padding: "2px 10px 5px",
                                      fontSize: 11,
                                      color: "#666666",
                                    }}
                                  >
                                    {`${companyAddress?.o_add1 || ""}, ${companyAddress?.o_add2 || ""}, `}
                                  </p>
                                  <p
                                    style={{
                                      textAlign: "center",
                                      lineHeight: 1.2,
                                      padding: "2px 10px 5px",
                                      margin: 0,
                                      fontSize: 11,
                                      color: "#666666",
                                    }}
                                  >
                                    {`${companyAddress?.o_add3 || ""}, ${companyAddress?.cityName || ""} - ${companyAddress?.o_pin || ""}, ${companyAddress?.Statename || ""} - ${companyAddress?.sCode || ""}`}
                                  </p>
                                  <p
                                    style={{
                                      textAlign: "center",
                                      lineHeight: 1.2,
                                      margin: 0,
                                      fontSize: 11,
                                      padding: "2px 10px 5px",
                                      color: "#666666",
                                    }}
                                  >
                                    Contact No : {printData.companyMobileNo},
                                    Email Id : {printData.companyEmail}
                                  </p>
                                  <p
                                    style={{
                                      textAlign: "center",
                                      lineHeight: 2,
                                      margin: 0,
                                      fontWeight: "700",
                                      fontSize: 11,
                                      padding: "2px 10px 5px",
                                      color: "#666666",
                                      letterSpacing: "1.2px",
                                    }}
                                  >
                                    GSTIN NO : {printData.companyGSTNo}, PAN NO
                                    :{printData.companyPanNo}
                                  </p>
                                  <p />
                                </td>
                              </tr>
                            </td>
                            {/* ── QR code: now matches Preview (QRCodeSVG) ── */}
                            <td
                              style={{
                                textAlign: "right",
                                width: "20%",
                                paddingRight: "20px",
                              }}
                            >
                              {decodedQRData && (
                                <QRCodeSVG
                                  value={JSON.stringify(decodedQRData)}
                                  size={80}
                                  level="H"
                                />
                              )}
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>

                    {/* ── DEBIT NOTE title ── */}
                    <tr>
                      <td style={{ padding: "0px" }}>
                        <table
                          style={{
                            width: "100%",
                            backgroundColor: "#efefef",
                            borderBottom: "1px solid #9f9e9e",
                            borderCollapse: "collapse",
                          }}
                        >
                          <tbody>
                            <tr>
                              <td style={{ width: "100%", padding: "3px" }}>
                                <h3
                                  style={{
                                    textTransform: "uppercase",
                                    fontSize: "11px",
                                    lineHeight: "16px",
                                    color: "#000",
                                    margin: "0px",
                                    fontFamily: '"popins-regular", sans-serif',
                                    textAlign: "center",
                                  }}
                                >
                                  DEBIT NOTE
                                </h3>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>

                    {/* ── Supplier / Bill info ── */}
                    <tr>
                      <td style={{ padding: "0px" }}>
                        <table
                          style={{
                            borderBottom: "1px solid #9f9e9e",
                            borderCollapse: "collapse",
                            width: "100%",
                          }}
                        >
                          <tbody>
                            <tr>
                              <td
                                className="padding-none"
                                width="50%"
                                style={{
                                  fontSize: 10,
                                  padding: 0,
                                  color: "#666666",
                                  verticalAlign: "top",
                                }}
                              >
                                <table
                                  border={0}
                                  cellSpacing={0}
                                  cellPadding={0}
                                  style={{ width: "100%" }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        className="label"
                                        style={{
                                          fontSize: 10,
                                          padding: "1px 6px",
                                          color: "#666666",
                                          verticalAlign: "top",
                                        }}
                                      >
                                        <p style={{ margin: "0 0 0px" }}>
                                          <b style={{ color: "#222222" }}>
                                            {`To : ${printData?.supplier || ""}`}
                                          </b>
                                        </p>
                                        <p
                                          style={{
                                            margin: "0 0 0px",
                                            minHeight: "18px",
                                          }}
                                        >
                                          {supplierAddress?.address1}
                                        </p>
                                        <p
                                          style={{
                                            margin: "0 0 0px",
                                            minHeight: "18px",
                                          }}
                                        >
                                          {supplierAddress?.address2}
                                        </p>
                                        <p
                                          style={{
                                            margin: "0 0 0px",
                                            minHeight: "18px",
                                          }}
                                        >
                                          {supplierAddress?.address3}
                                        </p>
                                        <p
                                          style={{
                                            margin: "0 0 0px",
                                            minHeight: "18px",
                                          }}
                                        >
                                          {`${supplierAddress?.cityName || ""} - ${supplierAddress?.pin || ""}, ${supplierAddress?.Statename || ""} - ${supplierAddress?.sCode || ""}`}
                                        </p>
                                        <p
                                          style={{
                                            margin: "0 0 0px",
                                            minHeight: "18px",
                                          }}
                                        >
                                          GSTIN NO :{" "}
                                          {printData?.supplierGSTNo || ""}
                                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;PAN
                                          NO : {printData?.supplierPanNo || ""}
                                        </p>
                                        <p
                                          style={{
                                            margin: "0 0 0px",
                                            minHeight: "18px",
                                          }}
                                        >
                                          Contact No :{" "}
                                          {`${printData?.supplierMobile || ""}/${printData?.supplierOfficeNumber || ""}`}
                                        </p>
                                        {printData?.supplierMSME &&
                                          printData?.supplierMSME != 0 && (
                                            <p
                                              style={{
                                                margin: "0 0 0px",
                                                minHeight: "18px",
                                              }}
                                            >
                                              MSME No :{" "}
                                              {printData?.supplierMSME || ""}
                                            </p>
                                          )}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                              <td
                                style={{
                                  padding: "0px",
                                  width: "50%",
                                  borderLeft: "1px solid #9f9e9e",
                                  verticalAlign: "top",
                                }}
                              >
                                <table style={{ width: "100%" }}>
                                  <tbody>
                                    <tr>
                                      <td
                                        style={{
                                          width: "100%",
                                          borderBottom: "1px solid #9f9e9e",
                                          padding: "0px 0px 0px 0px",
                                        }}
                                      >
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td
                                                className="label"
                                                style={{
                                                  fontSize: 10,
                                                  lineHeight: 1.5,
                                                  padding: "3.5px 6px",
                                                  color: "#666666",
                                                  verticalAlign: "top",
                                                  width: "50%",
                                                }}
                                              >
                                                <b style={{ color: "#222222" }}>
                                                  Debit No:
                                                </b>
                                                <span
                                                  style={{
                                                    paddingLeft: "18px",
                                                  }}
                                                >
                                                  {printData?.noteNo}
                                                </span>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td
                                                className="label"
                                                style={{
                                                  fontSize: 10,
                                                  lineHeight: 1.5,
                                                  padding: "3.5px 6px",
                                                  color: "#666666",
                                                  verticalAlign: "top",
                                                  width: "50%",
                                                }}
                                              >
                                                <b style={{ color: "#222222" }}>
                                                  Date:
                                                </b>
                                                <span
                                                  style={{
                                                    paddingLeft: "38px",
                                                  }}
                                                >
                                                  {moment(
                                                    printData?.noteDate,
                                                  ).format("DD/MM/YYYY")}
                                                </span>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td
                                                style={{ padding: "0px" }}
                                              ></td>
                                            </tr>
                                            <tr>
                                              <td
                                                style={{ padding: "0px" }}
                                              ></td>
                                            </tr>
                                            <tr>
                                              <td
                                                style={{ padding: "0px" }}
                                              ></td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <table style={{ width: "100%" }}>
                                          <tbody>
                                            <tr>
                                              <td
                                                className="label"
                                                style={{
                                                  fontSize: 10,
                                                  lineHeight: 1.5,
                                                  padding: "3.5px 6px",
                                                  color: "#666666",
                                                  verticalAlign: "top",
                                                  width: "50%",
                                                }}
                                              >
                                                <b style={{ color: "#222222" }}>
                                                  NOTE:
                                                </b>
                                                <span
                                                  style={{
                                                    paddingLeft: "32px",
                                                  }}
                                                >
                                                  GOOD RETURN AGAINST
                                                </span>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td
                                                className="label"
                                                style={{
                                                  fontSize: 10,
                                                  lineHeight: 1.5,
                                                  padding: "3.5px 6px",
                                                  color: "#666666",
                                                  verticalAlign: "top",
                                                  width: "50%",
                                                }}
                                              >
                                                <b style={{ color: "#222222" }}>
                                                  Bill No:
                                                </b>
                                                <span
                                                  style={{
                                                    paddingLeft: "29px",
                                                  }}
                                                >
                                                  {printData?.againstBillNo}
                                                </span>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td
                                                className="label"
                                                style={{
                                                  fontSize: 10,
                                                  lineHeight: 1.5,
                                                  padding: "3.5px 6px",
                                                  color: "#666666",
                                                  verticalAlign: "top",
                                                  width: "50%",
                                                }}
                                              >
                                                <b style={{ color: "#222222" }}>
                                                  Bill Date:
                                                </b>
                                                <span
                                                  style={{
                                                    paddingLeft: "20px",
                                                  }}
                                                >
                                                  {printData?.againstBillDate
                                                    ? moment(
                                                      printData?.againstBillDate,
                                                    ).format("DD-MM-YYYY")
                                                    : "-"}
                                                </span>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td style={{ padding: "0px" }}>
                        <table
                          style={{ width: "100%", borderCollapse: "collapse" }}
                        >
                          {/* ── Product table header ── */}
                          <thead>
                            <tr>
                              {[
                                { label: "Sr.", w: "3%" },
                                { label: "Product", w: "36.5%" },
                                { label: "HSN", w: "8%" },
                                { label: "Colour", w: "8%" },
                                { label: "Size", w: "8%" },
                                { label: "Unit", w: "8%" },
                                { label: "Qty", w: "8%" },
                                { label: "Rate", w: "8%" },
                              ].map((col) => (
                                <th
                                  key={col.label}
                                  style={{
                                    fontSize: "11px",
                                    lineHeight: "16px",
                                    color: "#222222",
                                    margin: "0px",
                                    textAlign: "left",
                                    borderRight: "1px solid #9f9e9e",
                                    borderBottom: "1px solid #9f9e9e",
                                    backgroundColor: "#efefef",
                                    padding: "3px 6px",
                                    width: col.w,
                                  }}
                                >
                                  {col.label}
                                </th>
                              ))}
                              <th
                                style={{
                                  fontSize: "11px",
                                  lineHeight: "16px",
                                  color: "#222222",
                                  margin: "0px",
                                  textAlign: "right",
                                  borderBottom: "1px solid #9f9e9e",
                                  backgroundColor: "#efefef",
                                  padding: "3px 6px",
                                  width: "8%",
                                }}
                              >
                                Amount
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {/* ── Product rows ── */}
                            {productData
                              ?.slice(dataPerPage * i, dataPerPage * (i + 1))
                              .map((row, index) => (
                                <tr
                                  key={index}
                                  style={{ borderBottom: "1px solid #9f9e9e" }}
                                >
                                  {[
                                    index + 1,
                                    row?.ProductName || "",
                                    row?.HSNCode || "",
                                    row?.color_name || "",
                                    row?.size_name || "",
                                    row?.unitCode || "",
                                    Number(row?.qty || 0).toFixed(2),
                                    Number(row?.rate || 0).toFixed(2),
                                  ].map((val, ci) => (
                                    <td
                                      key={ci}
                                      style={{
                                        fontSize: 9,
                                        lineHeight: "16px",
                                        fontWeight: 400,
                                        color: "#222222",
                                        margin: "0px",
                                        textAlign: "left",
                                        borderRight: "1px solid #9f9e9e",
                                        padding: "5px",
                                      }}
                                    >
                                      {val}
                                    </td>
                                  ))}
                                  <td
                                    style={{
                                      fontSize: 9,
                                      lineHeight: "16px",
                                      fontWeight: 400,
                                      color: "#222222",
                                      margin: "0px",
                                      textAlign: "right",
                                      padding: "5px",
                                    }}
                                  >
                                    {Number(row?.amount || 0).toFixed(2)}
                                  </td>
                                </tr>
                              ))}

                            {/* ── Empty filler rows (last page only) ── */}
                            {isLastPage &&
                              Array.from({ length: emptyData }).map(
                                (_, index) => (
                                  <tr key={`empty-${index}`}>
                                    <td
                                      style={{
                                        fontSize: "10px",
                                        lineHeight: "16px",
                                        fontWeight: 400,
                                        color: "transparent",
                                        margin: "0px",
                                        textAlign: "left",
                                        padding: "5px",
                                        height: 25,
                                      }}
                                      colSpan={4}
                                    >
                                      1
                                    </td>
                                    <td
                                      style={{
                                        fontSize: "10px",
                                        lineHeight: "16px",
                                        fontWeight: 400,
                                        color: "transparent",
                                        margin: "0px",
                                        textAlign: "left",
                                        padding: "5px",
                                        // borderLeft: "1px solid #9f9e9e",
                                        height: 25,
                                      }}
                                    >
                                      1
                                    </td>
                                  </tr>
                                ),
                              )}

                            {/* ── Total row ── */}

                            {/* ── Footer (last page only): matches Preview exactly ── */}
                            {isLastPage && (
                              <tr>
                                <td colSpan={9} style={{ padding: 0 }}>
                                  {/* Sub-total row */}
                                  <table
                                    style={{
                                      borderCollapse: "collapse",
                                      width: "100%",
                                    }}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          style={{
                                            fontSize: "10px",
                                            lineHeight: "16px",
                                            fontWeight: 400,
                                            // color: "#666666",
                                            fontWeight: "bold",

                                            margin: 0,
                                            textAlign: "left",
                                            borderTop: "1px solid #9f9e9e",
                                            borderRight: "1px solid #9f9e9e",
                                            borderBottom: "1px solid #9f9e9e",
                                            padding: "3px 15px",
                                            width: "86%",
                                          }}
                                        >
                                          MSME NO.:{printData?.MSMENo}
                                          <span style={{ marginLeft: "130px" }}>
                                            Eway Bill NO.:{" "}
                                            {printData?.ewaybillno || ""}
                                          </span>
                                        </td>
                                        <td
                                          style={{
                                            fontSize: "10px",
                                            lineHeight: "16px",
                                            fontWeight: 400,
                                            // color: "#666666",
                                            fontWeight: "bold",

                                            margin: 0,
                                            textAlign: "left",
                                            padding: "3px 15px",
                                            borderTop: "1px solid #9f9e9e",
                                            borderRight: "1px solid #9f9e9e",
                                            borderBottom: "1px solid #9f9e9e",
                                            // width: "8.3%",
                                            width: "5.6%",
                                          }}
                                        >
                                          Total
                                        </td>
                                        <td
                                          style={{
                                            fontSize: "10px",
                                            lineHeight: "16px",
                                            fontWeight: 400,
                                            // color: "#666666",
                                            margin: 0,
                                            fontWeight: "bold",

                                            textAlign: "right",
                                            padding: "3px 10px",
                                            borderTop: "1px solid #9f9e9e",
                                            borderBottom: "1px solid #9f9e9e",
                                            width: "8.4%",
                                            // width: "19.6%",
                                          }}
                                        >
                                          {(() => {
                                            const products = JSON.parse(
                                              printData?.productData || "[]",
                                            );
                                            const total = products.reduce(
                                              (sum, item) =>
                                                sum + (item.amount || 0),
                                              0,
                                            );
                                            return total.toFixed(2);
                                          })()}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>

                                  {/* Bank + Tax + Net Amount + Signatory */}
                                  <table
                                    style={{
                                      borderCollapse: "collapse",
                                      width: "100%",
                                      borderBottom: "1px solid #9f9e9e",
                                    }}
                                  >
                                    <tbody>
                                      <tr>
                                        {/* Left: Bank details + Terms & Conditions + IRN */}
                                        <td
                                          style={{
                                            width: "67%",
                                            borderRight: "1px solid #9f9e9e",
                                            verticalAlign: "top",
                                            padding: 0,
                                          }}
                                        >
                                          <table
                                            style={{
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  style={{
                                                    width: "25%",
                                                    fontSize: 10,
                                                    padding: "4px 8px",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  Bank Name
                                                </td>
                                                <td style={{ width: "2%" }}>
                                                  :
                                                </td>
                                                <td
                                                  style={{
                                                    width: "23%",
                                                    fontSize: 10,
                                                  }}
                                                >
                                                  {bankDetails?.BankName || ""}
                                                </td>
                                                <td
                                                  style={{
                                                    width: "25%",
                                                    fontSize: 10,
                                                    padding: "4px 8px",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  Branch Name
                                                </td>
                                                <td style={{ width: "2%" }}>
                                                  :
                                                </td>
                                                <td
                                                  style={{
                                                    width: "23%",
                                                    fontSize: 10,
                                                  }}
                                                >
                                                  {bankDetails?.Branchname ||
                                                    ""}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td
                                                  style={{
                                                    fontSize: 10,
                                                    padding: "4px 8px",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  A/C No
                                                </td>
                                                <td>:</td>
                                                <td style={{ fontSize: 10 }}>
                                                  {bankDetails?.Ac_No || ""}
                                                </td>
                                                <td
                                                  style={{
                                                    fontSize: 10,
                                                    padding: "4px 8px",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  IFSC Code
                                                </td>
                                                <td>:</td>
                                                <td style={{ fontSize: 10 }}>
                                                  {bankDetails?.IFSC_code || ""}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td
                                                  colSpan={6}
                                                  style={{
                                                    borderTop:
                                                      "1px solid #9f9e9e",
                                                    padding: "4px 8px",
                                                    fontSize: 9,
                                                  }}
                                                >
                                                  <p
                                                    style={{
                                                      margin: "0 0 2px 0",
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    Terms & Conditions
                                                  </p>
                                                  <p style={{ margin: 0 }}>
                                                    1) Payment within 30 Days.
                                                  </p>
                                                  <p style={{ margin: 0 }}>
                                                    2) In case of unpaid bill
                                                    intrest @24% will be charge
                                                    extra from the date of bill
                                                  </p>
                                                  <p style={{ margin: 0 }}>
                                                    3) Subject to MUMBAI
                                                    jurisdiction
                                                  </p>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td
                                                  colSpan={6}
                                                  style={{
                                                    borderTop:
                                                      "1px solid #9f9e9e",
                                                    padding: "4px 8px",
                                                    fontSize: 9,
                                                  }}
                                                >
                                                  <p
                                                    style={{
                                                      margin: "0 0 2px 0",
                                                    }}
                                                  >
                                                    <b>IRN No. :</b>{" "}
                                                    {printData?.IrnNo}
                                                  </p>
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                    }}
                                                  >
                                                    <span>
                                                      <b>ACK No. :</b>{" "}
                                                      {printData?.AckNo}
                                                    </span>
                                                    <span
                                                      style={{
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      E & O.E
                                                    </span>
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>

                                        {/* Right: Tax breakdown */}
                                        <td
                                          style={{
                                            width: "30%",
                                            verticalAlign: "top",
                                          }}
                                        >
                                          <table
                                            style={{
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                          >
                                            <tbody>
                                              {taxData?.map((tax, index) => (
                                                <tr key={index}>
                                                  <td
                                                    style={{
                                                      borderBottom:
                                                        "1px solid #9f9e9e",
                                                      borderRight:
                                                        "1px solid #9f9e9e",
                                                      fontSize: 10,
                                                      padding: "4px 8px",
                                                      textAlign: "center",
                                                      fontWeight: 600,
                                                      width: "73%",
                                                    }}
                                                  >
                                                    {[
                                                      "C.GST",
                                                      "I.GST",
                                                      "S.GST",
                                                    ].includes(tax?.tax_type)
                                                      ? `+${tax?.tax_type} ${tax?.taxRate}% ON ${tax?.taxOnAmt ?? ""}`
                                                      : `${tax?.tax_name}`}
                                                  </td>
                                                  <td
                                                    style={{
                                                      borderBottom:
                                                        "1px solid #9f9e9e",
                                                      fontSize: 10,
                                                      padding: "4px 8px",
                                                      textAlign: "right",
                                                      fontWeight: 600,
                                                      width: "40%",
                                                    }}
                                                  >
                                                    {tax?.amount}
                                                  </td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>

                                      {/* Rupees in words + NET AMOUNT */}
                                      <tr>
                                        <td
                                          style={{
                                            borderTop: "1px solid #9f9e9e",
                                            borderRight: "1px solid #9f9e9e",
                                            padding: "4px 8px",
                                            fontSize: 10,
                                            fontWeight: "bold",
                                            borderBottom: "1px solid #9f9e9e",
                                          }}
                                        >
                                          Rupees :{" "}
                                          {printData.totalAmount
                                            ? `${toWords.convert(printData.totalAmount)} Only.`
                                            : ""}
                                        </td>
                                        <td
                                          style={{
                                            padding: 0,
                                            verticalAlign: "top",
                                            borderBottom: "1px solid #9f9e9e",
                                          }}
                                        >
                                          <table
                                            style={{
                                              width: "100%",
                                              borderCollapse: "collapse",
                                            }}
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  style={{
                                                    width: "60%",
                                                    fontSize: 11,
                                                    padding: "4px 8px",
                                                    fontWeight: "bold",
                                                    borderRight:
                                                      "1px solid #9f9e9e",
                                                    borderTop:
                                                      "1px solid #9f9e9e",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  NET AMOUNT
                                                </td>
                                                <td
                                                  style={{
                                                    width: "40%",
                                                    fontSize: 11,
                                                    padding: "4px 8px",
                                                    fontWeight: "bold",
                                                    textAlign: "right",
                                                    borderTop:
                                                      "1px solid #9f9e9e",
                                                  }}
                                                >
                                                  {Number(
                                                    printData.totalAmount,
                                                  ).toFixed(2)}
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>

                                      {/* Bottom certification + dispute + signatory */}
                                      <tr>
                                        <td
                                          colSpan={2}
                                          style={{ padding: "0px" }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              width: "100%",
                                              alignItems: "stretch",
                                            }}
                                          >
                                            <div
                                              style={{
                                                width: "50%",
                                                fontSize: 9,
                                                padding: "8px",
                                              }}
                                            >
                                              <p style={{ margin: 0 }}>
                                                I/We hereby certify that my /
                                                our Registration certificate
                                                under The GST Act 2017 printing
                                                is in force on the date on which
                                                the sale of the goods specified
                                                in this bill / cash Memorandum
                                                is made by me/us and that the
                                                transaction of sale covered by
                                                this bill/cash memorandum has
                                                been effected by my / us in the
                                                regular course of my / our
                                                business.
                                              </p>
                                            </div>
                                            <div
                                              style={{
                                                width: "25%",
                                                fontSize: 9,
                                                padding: "8px",
                                                borderLeft: "1px solid #9f9e9e",
                                                borderRight:
                                                  "1px solid #9f9e9e",
                                              }}
                                            >
                                              <p style={{ margin: 0 }}>
                                                If any Dispute arises about
                                                transaction the same shall have
                                                to be referred to the HINDUSTAN
                                                CHAMBER OF COMMERCE / CMAI,
                                                Mumbai for under its arbitration
                                                rules and award made there under
                                                shall be binding upon.
                                              </p>
                                            </div>
                                            <div
                                              style={{
                                                width: "33.5%",
                                                textAlign: "right",
                                                fontSize: 11,
                                                padding: "8px",
                                              }}
                                            >
                                              <p
                                                style={{
                                                  fontWeight: "bold",
                                                  margin: "0 0 30px 0",
                                                }}
                                              >
                                                For{" "}
                                                {companyAddress?.Company_name ||
                                                  ""}
                                              </p>
                                              <p
                                                style={{
                                                  fontWeight: "bold",
                                                  margin: 0,
                                                }}
                                              >
                                                Authorised Signatory
                                              </p>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>

                {!isLastPage && (
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr>
                        <th
                          style={{
                            fontSize: "15px",
                            lineHeight: "20px",
                            fontWeight: 500,
                            color: "#666666",
                            margin: "0px",
                            textAlign: "center",
                            padding: "5px",
                            paddingTop: 15,
                          }}
                          colSpan={9}
                        >
                          {`Continue to page ${i + 2}`}
                        </th>
                      </tr>
                    </thead>
                  </table>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
